export interface ApiConfig {
	rcs: string[];
	params?: ApiParams[];
}
export interface ApiParams {
	paramId: string;
	value: string;
	type: API_PARAM_TYPE.IDENTIFIER;
}
export namespace API_PARAM_TYPE {
	export enum IDENTIFIER {
		PARAM,
		OTHER
	}
}
